import { FeatureFlagService, FlagName } from '@/contracts/FeatureFlagService';

// Backed by VUE_APP_FEATURE_* env vars, inlined at build time per environment
// (vite.config.mts's loadEnv(..., 'VUE_APP_')) — "turn a flag on" means
// editing one .env* file and redeploying that environment, not a runtime
// toggle. Only add the var to the .env* files where it's actually `true` —
// a missing var already resolves to `false`, so leaving it out of the rest
// keeps both adding and removing a flag a one- or two-file change.
//
// Record<FlagName, boolean> (keyed by the contract's union, not the other
// way around) so TS errors if this map ever drifts out of sync with FlagName.
const flags: Record<FlagName, boolean> = {
	// New Workbench tabbed/Locations UI (FACT-5827+) vs. today's single-pane
	// workbench. Remove this entry and WORKBENCH_NEW_UI's `v-if` in
	// ViewWorkbench.vue once the new UI has been in prod a couple of weeks.
	WORKBENCH_NEW_UI: process.env.VUE_APP_FEATURE_WORKBENCH_NEW_UI === 'true',
};

export class EnvFeatureFlagService implements FeatureFlagService {
	// Optional override for tests — the substitution above happens at
	// build/transform time, so flipping the env var at test runtime has
	// nothing left to affect.
	constructor(private readonly flagMap: Record<string, boolean> = flags) {}

	isEnabled(flag: string): boolean {
		return Object.hasOwn(this.flagMap, flag) && this.flagMap[flag];
	}
}

const featureFlagService = new EnvFeatureFlagService();
export default featureFlagService;
